// /**
//  * ConsentScreen — Reusable, config-driven
//  *
//  * Matches the pattern used in CareNavigator.jsx:
//  *   - Uses styles from carenavigator.module.css
//  *   - Data comes from CONFIG.screens.consent (carenavigator.json)
//  *   - Same SidePanel, Checkbox, NavRow sub-components
//  *
//  * Props:
//  *   config    — CONFIG.screens.consent object (see carenavigator.json)
//  *   onNext()  — called when all required consents are checked
//  *   onBack()  — called when user clicks Back
//  *   styles    — your carenavigator.module.css import (passed in so this file stays portable)
//  *
//  * Usage inside CareNavigator.jsx:
//  *
//  *   import ConsentScreen from './ConsentScreen';
//  *
//  *   {screen === 'consent' && (
//  *     <ConsentScreen
//  *       config={CONFIG.screens.consent}
//  *       onNext={next}
//  *       onBack={back}
//  *       styles={styles}
//  *     />
//  *   )}
//  *
//  * Usage anywhere else (pass your own config or override fields):
//  *
//  *   import ConsentScreen from './ConsentScreen';
//  *   import styles from '../styles/carenavigator.module.css';
//  *   import CONFIG from '../config/carenavigator.json';
//  *
//  *   <ConsentScreen
//  *     config={CONFIG.screens.consent}
//  *     onNext={handleNext}
//  *     onBack={handleBack}
//  *     styles={styles}
//  *   />
//  */

// import { useState } from 'react';
// import StepperProgress from '../../Reusablesteps/Stepperprogress';
// import Button, { BtnBack, BtnContinue } from '../Button/Reusableutton';
// import styles from './consent.module.css';

// /* ─── Inline SVG icons (same pattern as CareNavigator.jsx) ─────────────────── */

// const ArrowRight = ({ size = 16, color = 'currentColor' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2.5} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
//   </svg>
// );

// const ArrowLeft = ({ size = 16, color = 'currentColor' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2.5} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
//   </svg>
// );

// const Check = ({ size = 12, color = 'white' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={3} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
//   </svg>
// );

// const Lock = ({ size = 14, color = 'currentColor' }) => (
//   <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
//   </svg>
// );

// const ChevronDown = ({ size = 12 }) => (
//   <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
//   </svg>
// );

// /* ─── Checkbox — identical to CareNavigator ─────────────────────────────────── */

// function Checkbox({ checked, onChange,  }) {
//   return (
//     <div
//       className={`${styles.checkbox} ${checked ? styles.checked : ''}`}
//       onClick={onChange}
//       role="checkbox"
//       aria-checked={checked}
//       tabIndex={0}
//       onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && onChange()}
//     >
//       {checked && <Check size={12} />}
//     </div>
//   );
// }

// /* ─── Toggle — identical to CareNavigator ───────────────────────────────────── */

// function Toggle({ checked, onChange,  }) {
//   return (
//     <label className={styles.toggle}>
//       <input type="checkbox" checked={checked} onChange={onChange} />
//       <div className={styles.toggleTrack} />
//       <div className={styles.toggleThumb} />
//     </label>
//   );
// }

// /* ─── SidePanel — identical to CareNavigator ────────────────────────────────── */

// function SidePanel({ title, items, extra, }) {
//   return (
//     <div className={styles.sidePanelCard}>
//       {title && <div className={styles.sidePanelTitle}>{title}</div>}
//       {items && (
//         <div className={styles.sidePanelList}>
//           {items.map((item, i) => (
//             <div key={i} className={styles.sidePanelItem}>
//               <div className={styles.sidePanelItemIcon}>{item.icon}</div>
//               <div>
//                 <div className={styles.sidePanelItemTitle}>{item.title}</div>
//                 {item.desc && <div className={styles.sidePanelItemDesc}>{item.desc}</div>}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//       {extra}
//     </div>
//   );
// }

// /* ─── Single consent row ────────────────────────────────────────────────────── */

// function ConsentItem({ item, isToggle, checked, onToggle, }) {
//   const [expanded, setExpanded] = useState(false);

//   return (
//     <div className={styles.consentItem} onClick={onToggle}>
//       <div className={styles.consentItemIcon}>{item.icon}</div>

//       <div className={styles.consentItemBody}>
//         <div className={styles.consentItemTitle}>{item.title}</div>
//         <div className={styles.consentItemDesc}>{item.description}</div>

//         <button
//           className={styles.consentViewDetails}
//           onClick={(e) => { e.stopPropagation(); setExpanded((p) => !p); }}
//         >
//           View details <ChevronDown size={11} />
//         </button>

//         {expanded && (
//           <p style={{ fontSize: 12, color: '#6b7280', marginTop: 6, lineHeight: 1.6 }}>
//             This consent is required to personalize your care experience and comply
//             with applicable healthcare data regulations.
//           </p>
//         )}
//       </div>

//       {/* Clicking the control itself must not also fire the row's onToggle */}
//       <div className={styles.consentCheckbox} onClick={(e) => e.stopPropagation()}>
//         {isToggle
//           ? <Toggle checked={checked} onChange={onToggle} styles={styles} />
//           : <Checkbox checked={checked} onChange={onToggle} styles={styles} />
//         }
//       </div>
//     </div>
//   );
// }

// /* ─── Main ConsentScreen ────────────────────────────────────────────────────── */

// export default function ConsentScreen({ config, onNext, onBack,stepIndex,totalSteps }) {
//   const C = config;

//   const [checkedReq, setCheckedReq] = useState({});   // { [item.id]: boolean }
//   const [toggledOpt, setToggledOpt] = useState({});   // { [item.id]: boolean }

//   const flipReq = (id) => setCheckedReq((p) => ({ ...p, [id]: !p[id] }));
//   const flipOpt = (id) => setToggledOpt((p) => ({ ...p, [id]: !p[id] }));

//   // Continue is enabled only when every required item is checked
//   const allRequired = (C.requiredItems ?? []).every((item) => !!checkedReq[item.id]);

//   return (
//     <div>
//       {/* ── Header ── */}
//       <div className={styles.screenHeader}>
//         <div className={styles.screenHeaderText}>
//           <h1 className={styles.pageTitle}>{C.pageTitle}</h1>
//           <p className={styles.pageSubtitle}>{C.pageSubtitle}</p>
//         </div>
//         {totalSteps ? 
//           <StepperProgress current={stepIndex} total={totalSteps} />
//         :""}
//       </div>

//       {/* ── Two-column body ── */}
//       <div className={styles.twoCol}>

//         {/* Left — consent items */}
//         <div>

//           {/* Required */}
//           {(C.requiredItems ?? []).length > 0 && (
//             <div className={styles.consentSection}>
//               <div className={styles.consentSectionLabel}>Required</div>
//               {C.requiredItems.map((item) => (
//                 <ConsentItem
//                   key={item.id}
//                   item={item}
//                   isToggle={false}
//                   checked={!!checkedReq[item.id]}
//                   onToggle={() => flipReq(item.id)}
//                   styles={styles}
//                 />
//               ))}
//             </div>
//           )}

//           {/* Optional — renders only when the array is non-empty */}
//           {(C.optionalItems ?? []).length > 0 && (
//             <div className={styles.consentSection} style={{ marginTop: 16 }}>
//               <div className={styles.consentSectionLabel}>Optional</div>
//               {C.optionalItems.map((item) => (
//                 <ConsentItem
//                   key={item.id}
//                   item={item}
//                   isToggle={true}
//                   checked={!!toggledOpt[item.id]}
//                   onToggle={() => flipOpt(item.id)}
//                   styles={styles}
//                 />
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Right — side panel */}
//         <div className={styles.sideCol}>
//           <SidePanel
//             title={C.sideCard.title}
//             items={C.sideCard.items}
//             styles={styles}
//             extra={
//               C.sideCard.infoBubble ? (
//                 <div className={styles.consentInfoBubble} style={{ marginTop: 12 }}>
//                   <span style={{ fontSize: 15 }}>ℹ️</span>
//                   <span className={styles.consentInfoBubbleText}>
//                     {C.sideCard.infoBubble}
//                   </span>
//                 </div>
//               ) : null
//             }
//           />
//         </div>
//       </div>

//       {/* ── Nav row ── */}
//       <div className={styles.navRow}>
//         {/* <button className={styles.btnOutline} onClick={onBack}>
//           <ArrowLeft size={15} /> Back
//         </button> */}
//           <BtnBack variant="outline" onClick={onBack}/>
//           <BtnContinue variant="primary" onClick={onNext} lock={true} disabled={!allRequired} label={C.sideCard.ctaLabel}/>
//             {/* <Lock size={14} color="white" /> */}
//         {/* <button
//           className={styles.btnPrimary}
//           onClick={onNext}
//           disabled={!allRequired}
//           style={{ display: 'flex', alignItems: 'center', gap: 8 }}
//         >
//           <Lock size={14} color="white" />
          
//           <ArrowRight size={15} color="white" />
//         </button> */}
//       </div>
//     </div>
//   );
// }
/**
 * ConsentScreen — Reusable, config-driven
 *
 * Matches the pattern used in CareNavigator.jsx:
 *   - Uses styles from carenavigator.module.css
 *   - Data comes from CONFIG.screens.consent (carenavigator.json)
 *   - Same SidePanel, Checkbox, NavRow sub-components
 *
 * Props:
 *   config    — CONFIG.screens.consent object (see carenavigator.json)
 *   onNext()  — called when all required consents are checked
 *   onBack()  — called when user clicks Back
 *   styles    — your carenavigator.module.css import (passed in so this file stays portable)
 *
 * Usage inside CareNavigator.jsx:
 *
 *   import ConsentScreen from './ConsentScreen';
 *
 *   {screen === 'consent' && (
 *     <ConsentScreen
 *       config={CONFIG.screens.consent}
 *       onNext={next}
 *       onBack={back}
 *       styles={styles}
 *     />
 *   )}
 *
 * Usage anywhere else (pass your own config or override fields):
 *
 *   import ConsentScreen from './ConsentScreen';
 *   import styles from '../styles/carenavigator.module.css';
 *   import CONFIG from '../config/carenavigator.json';
 *
 *   <ConsentScreen
 *     config={CONFIG.screens.consent}
 *     onNext={handleNext}
 *     onBack={handleBack}
 *     styles={styles}
 *   />
 */

import { useState } from 'react';
import StepperProgress from '../../Reusablesteps/Stepperprogress';
import Button, { BtnBack, BtnContinue } from '../Button/Reusableutton';
import styles from './consent.module.css';
import { ScreenHeaderDFO } from '../../HealthAssessment/SharedUI';
import { useCareJourneyContent } from '../../../hooks/useCareJourneyContent';

/* ─── Inline SVG icons (same pattern as CareNavigator.jsx) ─────────────────── */

const ArrowRight = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2.5} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
  </svg>
);

const ArrowLeft = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2.5} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
  </svg>
);

const Check = ({ size = 12, color = 'white' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={3} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
  </svg>
);

const Lock = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} fill="none" stroke={color} strokeWidth={2} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
  </svg>
);

const ChevronDown = ({ size = 12 }) => (
  <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
  </svg>
);

/* ─── Checkbox — identical to CareNavigator ─────────────────────────────────── */

function Checkbox({ checked, onChange, }) {
  return (
    <div
      className={`${styles.checkbox} ${checked ? styles.checked : ''}`}
      onClick={onChange}
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && onChange()}
    >
      {checked && <Check size={12} />}
    </div>
  );
}

/* ─── Toggle — identical to CareNavigator ───────────────────────────────────── */

function Toggle({ checked, onChange, }) {
  return (
    <label className={styles.toggle}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <div className={styles.toggleTrack} />
      <div className={styles.toggleThumb} />
    </label>
  );
}

/* ─── SidePanel — identical to CareNavigator ────────────────────────────────── */

function SidePanel({ title, items, extra, }) {
  return (
    <div className={styles.sidePanelCard}>
      {title && <div className={styles.sidePanelTitle}>{title}</div>}
      {items && (
        <div className={styles.sidePanelList}>
          {items.map((item, i) => (
            <div key={i} className={styles.sidePanelItem}>
              <div className={styles.sidePanelItemIcon}>{item.icon}</div>
              <div>
                <div className={styles.sidePanelItemTitle}>{item.title}</div>
                {item.desc && <div className={styles.sidePanelItemDesc}>{item.desc}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
      {extra}
    </div>
  );
}

/* ─── Single consent row ────────────────────────────────────────────────────── */

function ConsentItem({ item, isToggle, checked, onToggle, }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.consentItem} onClick={onToggle}>
      <div className={styles.consentItemIcon}>{item.icon}</div>

      <div className={styles.consentItemBody}>
        <div className={styles.consentItemTitle}>{item.title}</div>
        <div className={styles.consentItemDesc}>{item.description}</div>

        <button
          className={styles.consentViewDetails}
          onClick={(e) => { e.stopPropagation(); setExpanded((p) => !p); }}
        >
          View details <ChevronDown size={11} />
        </button>

        {/* {expanded && (
          <p style={{ fontSize: 12, color: '#6b7280', marginTop: 6, lineHeight: 1.6 }}>
            This consent is required to personalize your care experience and comply
            with applicable healthcare data regulations.
          </p>
        )} */}
        {expanded && (
          <p style={{ fontSize: 12, color: '#6b7280', marginTop: 6, lineHeight: 1.6 }}>
            {item.details ?? "This consent is required to personalize your care experience and comply with applicable healthcare data regulations."}
          </p>
        )}
      </div>

      {/* Clicking the control itself must not also fire the row's onToggle */}
      <div className={styles.consentCheckbox} onClick={(e) => e.stopPropagation()}>
        {isToggle
          ? <Toggle checked={checked} onChange={onToggle} styles={styles} />
          : <Checkbox checked={checked} onChange={onToggle} styles={styles} />
        }
      </div>
    </div>
  );
}

/* ─── Main ConsentScreen ────────────────────────────────────────────────────── */

export default function ConsentScreen({ config, onNext, onBack, stepIndex, totalSteps }) {
  // const C = config;
  // const {content, loading,error}=useCareJourneyContent();
  // const C=content;
  const { content, loading, error } = useCareJourneyContent();



  const [checkedReq, setCheckedReq] = useState({});   // { [item.id]: boolean }
  const [toggledOpt, setToggledOpt] = useState({});   // { [item.id]: boolean }

  const flipReq = (id) => setCheckedReq((p) => ({ ...p, [id]: !p[id] }));
  const flipOpt = (id) => setToggledOpt((p) => ({ ...p, [id]: !p[id] }));

  // Continue is enabled only when every required item is checked

if (loading) {
  return <div>Loading...</div>;
}

if (error) {
  return <div>Error loading content</div>;
}

if (!content) {
  return null;
}

const C = content.screens.consent;
console.log(C,"tccccccccccccccccccccc")
  const allRequired = (C.requiredItems ?? []).every((item) => !!checkedReq[item.id]);
  return (
    <div>
      {/* ── Header ── */}
      <div className={styles.screenHeader}>
        <div className={styles.screenHeaderText}>
          <h1 className={styles.pageTitle}>{C.pageTitle}</h1>
          <p className={styles.pageSubtitle}>{C.pageSubtitle}</p>
        </div>
        {totalSteps ?
          <StepperProgress current={stepIndex} total={totalSteps} />
          : ""}
      </div>

      {/* ── Two-column body ── */}
      <div className={styles.twoCol}>

        {/* Left — consent items */}
        <div>

          {/* Required */}
          {(C.requiredItems ?? []).length > 0 && (
            <div className={styles.consentSection}>
              <div className={styles.consentSectionLabel}>Required</div>
              {C.requiredItems.map((item) => (
                <ConsentItem
                  key={item.id}
                  item={item}
                  isToggle={false}
                  checked={!!checkedReq[item.id]}
                  onToggle={() => flipReq(item.id)}
                  styles={styles}
                />
              ))}
            </div>
          )}

          {/* Optional — renders only when the array is non-empty */}
          {(C.optionalItems ?? []).length > 0 && (
            <div className={styles.consentSection} style={{ marginTop: 16 }}>
              <div className={styles.consentSectionLabel}>Optional</div>
              {C.optionalItems.map((item) => (
                <ConsentItem
                  key={item.id}
                  item={item}
                  isToggle={true}
                  checked={!!toggledOpt[item.id]}
                  onToggle={() => flipOpt(item.id)}
                  styles={styles}
                />
              ))}
            </div>
          )}
        </div>

        {/* Right — side panel */}
        <div className={styles.sideCol}>
          <SidePanel
            title={C.sideCard.title}
            items={C.sideCard.items}
            styles={styles}
            extra={
              C.sideCard.infoBubble ? (
                <div className={styles.consentInfoBubble} style={{ marginTop: 12 }}>
                  <span style={{ fontSize: 15 }}>ℹ️</span>
                  <span className={styles.consentInfoBubbleText}>
                    {C.sideCard.infoBubble}
                  </span>
                </div>
              ) : null
            }
          />
        </div>
      </div>

      {/* ── Nav row ── */}
      <div className={styles.navRow}>
        {/* <button className={styles.btnOutline} onClick={onBack}>
          <ArrowLeft size={15} /> Back
        </button> */}
        <BtnBack variant="outline" onClick={onBack} />
        <BtnContinue variant="primary" onClick={onNext} disabled={!allRequired} label={C.sideCard.ctaLabel} />
        {/* <Lock size={14} color="white" /> */}
        {/* <button
          className={styles.btnPrimary}
          onClick={onNext}
          disabled={!allRequired}
          style={{ display: 'flex', alignItems: 'center', gap: 8 }}
        >
          <Lock size={14} color="white" />
          
          <ArrowRight size={15} color="white" />
        </button> */}
      </div>
    </div>
  );
}